import 'css-chunksrc/client/scenes/assignToTask/tasksSelection/tasks/task/styles.scss';export default {
  "task": "_task_6o85d_1",
  "name": "_name_6o85d_12"
};